<template>
    <section
        class="w-[380px] bg-[var(--background-primary)] border border-[var(--background-btn)] text-white p-4 rounded-xl shadow-lg">
        <!-- Title -->
        <h2 class="text-lg font-semibold mb-3">Promo Code &amp; Offers</h2>

        <!-- Coupon Input with Button Inside -->
        <div class="relative mb-5">
            <input v-model="couponCode" type="text" placeholder="Enter Coupon Code"
                class="w-full px-3 py-2 pr-20 bg-[#11182C] rounded-md text-sm border border-gray-600 outline-none" />
            <Button unstyled label="Apply"
                class="absolute right-1 top-1/2 -translate-y-1/2 h-[32px] px-3 text-xs rounded-md bg-gradient-to-r from-indigo-500 to-blue-500 text-white"
                @click="applyCoupon" />
        </div>

        <!-- Best Coupons -->
        <h3 class="text-sm text-gray-300 mb-2">Best coupons for you</h3>

        <div class="space-y-3">
            <div v-for="(coupon, index) in coupons" :key="index"
                class="flex items-center justify-between bg-[#11182C] px-3 py-3 rounded-lg border border-gray-700">
                <div>
                    <p class="text-sm font-medium">{{ coupon.code }}</p>
                    <p class="text-xs text-green-400">{{ coupon.savings }}</p>
                </div>
                <Button unstyled label="Apply"
                    class="px-4 py-1 text-sm rounded-md bg-gradient-to-r from-indigo-500 to-blue-500 text-white"
                    @click="applyBestCoupon(coupon.code)" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">

const couponCode = ref("");

const coupons = ref([
    { code: "MYSAVINGS10", savings: "Save €100" },
    { code: "WELCOME50", savings: "Save €50" }
]);

const applyCoupon = () => {
    alert(`Coupon Applied: ${couponCode.value}`);
};

const applyBestCoupon = (code: string) => {
    alert(`Best Coupon Applied: ${code}`);
};
</script>

<style scoped></style>
